import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileManagerModalComponent } from './components/file-manager-modal/file-manager-modal.component';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { DndModule } from 'ngx-drag-drop';
import { CreateDirectoryModalComponent } from './components/create-directory-modal/create-directory-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { FileManagerConfig } from './FileManagerConfig';
import { FileManagerService } from './services/file-manager.service';
import {NgxFilesizeModule} from 'ngx-filesize';
import { DialogModule } from '../dialog/dialog.module';
import { AlertFacadeServiceModule } from '../alert-facade-service/alert-facade-service.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [FileManagerModalComponent, CreateDirectoryModalComponent],
  entryComponents: [FileManagerModalComponent, CreateDirectoryModalComponent],
  providers: [],
  imports: [
    CommonModule,
    FomanticUIModule,
    ReactiveFormsModule,
    DialogModule,
    DndModule,
    NgxFilesizeModule,
    AlertFacadeServiceModule,
    FormsModule
  ],
  exports: [FileManagerModalComponent, CreateDirectoryModalComponent]
})
export class FileManagerModule {
  static forRoot(config: FileManagerConfig): ModuleWithProviders<FileManagerModule> {
    return {
      ngModule: FileManagerModule,
      providers: [FileManagerService, {provide: 'config', useValue: config}]
    };
  }
}